export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 5; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);
  // console.log(a);

  return a;
};

export const cuppon_type = {
  percentage: "percentage",
  fixedamount: "fixedamount",
};

export const variant_type = {
  Single: 1,
  Double: 2,
  Triple: 3,
};

export const product_coupon = {
  Percentage: "Percentage",
  FixedAmount: "Fixed Amount",
};

export const product_type = {
  B2B: "Bulk Order",
  B2C: "Home Page",
  SampleRoll: "Sample Roll",
};

export const ImageValidation = {
  files_type: ["jpg", "png", "jpeg", "webp"],
  product: { w: 578, h: 762 },
};

export const RequiredIs = {
  roles: [1],
  service_term: [1, 2, 3, 4],
  service_type: [1, 2, 3],
  product_type: [1, 2, 3, 4],
};

export const Select2Data = async (data, name, other = false) => {
  const result = data?.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const SelectImageData = async (data, name) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
    image: data?.image,
  }));

  return result;
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}

export const ProductNarrationChange = (e) => {
  const { value } = e.target;
  const capitalizedValue = value
    .split(" ")
    .map((word) => word.trim())
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return capitalizedValue;
};

export const ProductNarrationChangeComa = (e) => {
  const { value } = e.target;
  const capitalizedValue = value
    .split(",")
    .map((word) => word.trim())
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(",");
  return capitalizedValue;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-GB", options).replace(",", "");
};

export const validateImage = async (file, size = 500) => {
  if (!file) {
    return false;
  }

  return true;
  // if (!file) return "Image is required";

  // Check file size (500KB = 500 * 1024 bytes)
  const maxSizeInBytes = size * 1024;
  if (file.size > maxSizeInBytes) {
    return false;
    // return "Image size must be less than or equal to 500KB";
  }

  return new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      const aspectRatio = img.width / img.height;

      if (aspectRatio.toFixed(1) == 0.5) {
        resolve(true);
      } else {
        resolve(false);
        // resolve("Image aspect ratio must be 1:2 (width:height)");
      }
    };
    img.onerror = () => {
      resolve(false);
      // resolve("Invalid image file");
    };
  });
};

export const validateVideo = async (file, size = 5, duration = 40) => {
  return new Promise((resolve) => {
    if (!file) {
      resolve(false);
      return;
    }

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      const v_duration = video.duration;
      const v_size = file.size / (1024 * 1024); // size in MB

      if (v_duration > duration) {
        resolve(false);
      } else if (v_size > size) {
        resolve(false);
      } else {
        resolve(true);
      }
    };

    video.src = URL.createObjectURL(file);
  });
};

// export const formatDateToIST = (isoDate) => {
//   const date = new Date(isoDate);
//   return date.toLocaleString("en-IN", {
//     timeZone: "Asia/Kolkata",
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     // hour: "2-digit",
//     // minute: "2-digit",
//     // second: "2-digit",
//     // hour12: true, // Optional: use 12-hour format with AM/PM
//   });
// };

export const formatDateToIST = (isoDate) => {
  const date = new Date(isoDate);

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Shows AM/PM
  });
};

export const RoleId = {
  Admin: 1,
  Doctor: 2,
  Vendor: 3,
  Customer: 4,
  DeliveryBoy: 5,
  Vender: 7,
};

export const ApprovalStatus = {
  Pending: 1,
  Approved: 2,
  Rejected: 3,
  UnderReview: 4,
  OnHold: 5,
};

export const Types = {
  FrameSize: 1,
  FrameMaterial: 2,
  GlassDetail: 3,
  MountType: 4,
  Printing: 5,
  PrintingOptional: 6,
  SelectThickness: 7,
  SelectSlides: 8,
  FrameOption: 9,
};

export const FrameType = {
  WOODEN: 1,
  METAL: 2,
  SYNTHETIC: 3,
};

export const OrderStatusIds = {
  // Pending: 1,
  // Processing: 2,
  // Preparing: 3,
  // OrderUnderQualityCheck: 4,
  // Pickup: 5,
  // Delivered: 6,
  // Cancelled: 7,
  // Returned: 8,
  // Refunded: 9,
  // Replaced: 10,
  // Rejected: 11,
  // Packing: 12,
  // Requested: 1,
  // Pending: 2,
  // Accept: 3,
  // Processing: 4,
  // Shipping: 5,
  // OutForDelivery: 6,
  // Delivered: 7,
  // Cancelled: 8,
  // Returned: 9,
  Requested: 1,
  Pending: 2,
  Accept: 3,
  Processing: 4,
  Shipping: 5,
  OutForDelivery: 6,
  Delivered: 7,
  Cancelled: 8,
  Returned: 9,
};

export const ReturnStatusIds = {
  ReturnRequested: 1,
  PickupScheduled: 2,
  ItemPicked: 3,
  Returned: 4,
  RefundProcess: 5,
  Refunded: 6,
  ReturnRejected: 7,
};

export const ReplaceStatusIds = {
  ReplaceRequested: 1,
  StoreItmePickupScheduled: 2,
  StoreItemPicked: 3,
  // CustomerReplaceItem: 4,
  CustomerItemReplaced: 4,
  StoreReplaceItemDelivered: 5,
  ReplaceItemRejected: 6,
};

export const ServiceIds = {
  DineIn: 1,
  RoomService: 2,
  Delivery: 3,
  PickUp: 4,
};

export const Gender = {
  Male: 1,
  Female: 2,
  Other: 3,
};

export const ItemType = {
  Product: 1,
  Food: 2,
  Other: 3,
};

export const CouponType = {
  FixedAmount: 1,
  Percentage: 2,
  FreeShipping: 3,
  BuyOneGetOne: 4,
  FreeGift: 5,
};

export const ContactType = {
  Phone: 1,
  Email: 2,
  Address: 3,
  SocialMedia: 4,
};

export const PaymentMethods = {
  Cash: 1,
  Card: 2,
  QR: 3,
};

// Pages of the Page Master (same ids as the pages seeder / backend fix_ids.js)
export const Pages = {
  Homepage: 1,
  Products: 2,
  ProductDetails: 3,
  NewArrivals: 4,
  WallArt: 5,
  CanvasPrints: 6,
  StretchedCanvasPrint: 7,
  PrintOnly: 8,
  FramePrintWithMat: 9,
  FramePrintWithoutMat: 10,
  CollageFrame: 11,
  BeAKarigar: 12,
  Blogs: 13,
  BlogDetails: 14,
  ContactUs: 15,
  PrivacyPolicy: 16,
  ReturnPolicy: 17,
  TermsAndConditions: 18,
  Cart: 19,
  Wishlist: 20,
  Login: 21,
};

// Sections of the Section Master (same ids as the sections seeder / backend fix_ids.js)
export const Sections = {
  BannerTitle: 1,
  ExploreCategories: 2,
  WhereYourMemoriesMeet: 3,
  WhyFrameKarigar: 4,
  BrowseOurExclusiveCollection: 5,
  TrustedByIndiasLeadingBrands: 6,
  PostersCollection: 7,
  CustomersChoiceCollection: 8,
  WhatOurCustomersSay: 9,
  FramingTipsAndInspiration: 10,
};

export const IDS = {
  Dashboard: { View: 264 },
  Role: { List: 1, Add: 2, Edit: 3, Delete: 4, Status: 265 },
  Salesperson: { List: 5, Add: 6, Edit: 7, Delete: 8, Status: 266 },
  Customer: { List: 105, View: 283, Status: 107, Delete: 108 },
  ProductCategory: { List: 37, Add: 38, Edit: 39, Delete: 40, Status: 271 },
  ProductSubCategory: { List: 41, Add: 42, Edit: 43, Delete: 44, Status: 272 },
  ProductChildCategory: { List: 45, Add: 46, Edit: 47, Delete: 48, Status: 273 },
  Type: { List: 244, Edit: 246 },
  Frame_Type: { List: 260, Add: 261, Edit: 262, Delete: 263, Status: 282 },
  Sub_Type: { List: 248, Add: 249, Edit: 250, Delete: 251, Status: 280 },
  Product: { List: 85, Add: 86, Edit: 87, Delete: 88, Status: 275 },
  Custom_Product: { List: 285, Add: 286, Edit: 287, Delete: 288, Status: 289 },
  ProductRating: { List: 93, Add: 94, Edit: 95, Delete: 96, Status: 277 },
  ProductReview: { List: 290, Add: 291, Edit: 292, Delete: 293, Status: 294 },
  Order: { List: 101, View: 284, Status: 103 },
  Coupon: { List: 109, Add: 110, Edit: 111, Delete: 112, Status: 278 },
  Brand: { List: 61, Add: 62, Edit: 63, Delete: 64, Status: 274 },
  AppSetup: { List: 169, Edit: 171 },
  SocialLink: { List: 173, Add: 174, Edit: 175, Delete: 176, Status: 279 },
  HomeBanner: { List: 89, Add: 90, Edit: 91, Delete: 92, Status: 276 },
  Why_Frame_Karigar: { List: 252, Add: 253, Edit: 254, Delete: 255, Status: 281 },
  TermsAndCondition: { List: 161, Add: 162, Edit: 163 },
  PrivacyPolicy: { List: 165, Add: 166, Edit: 167 },
  Return_Policy: { List: 256, Add: 257, Edit: 258 },
  OurCustomerSays: { List: 295, Add: 296, Edit: 297, Delete: 298, Status: 299 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12, Status: 267 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16, Status: 268 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20, Status: 269 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24, Status: 270 },
  Blog: { List: 300, Add: 301, Edit: 302, Delete: 303, Status: 304, TopStatus: 305 },
  ContactUsForm: { List: 306, Delete: 307 },
  Page: { List: 308, Add: 309, Edit: 310, Status: 311 },
  Meta_Page: { List: 312, Add: 313, Edit: 314 },
  Section: { List: 315, Add: 316, Edit: 317, Status: 318 },
  Meta_Section: { List: 319, Add: 320, Edit: 321 },
};
